var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btns"},[(_vm.cancelbtn)?_c('button',{staticClass:"cancel",on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("取消")]):_vm._e(),_c('button',{staticClass:"confirm",on:{"click":function($event){return _vm.$emit('confirm')}}},[_vm._v(_vm._s(_vm.confirmLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }